import React, { useEffect, useState, useLayoutEffect } from "react";
import InstallationAddDeviceView from "./InstallationAddDeviceView";
import crmservices from "../../wsclient";
import { useTranslation } from "react-i18next";
import LoadingComponent from "../../components/Loading";
import AlertComponent from "../../components/Alert";
import { Dialog, DialogContent, Grid } from "@mui/material";
import LinearBuffer from "./LinearBuffer";
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";
import TotalActivitiesAddDeviceView from "./AdditionalBoxView";
import AdditionalBoxView from "./AdditionalBoxView";
import { createCustomFieldObj, getCustomFieldByKey, sleep } from "../../utils/util";

export default function AdditionalBoxController(props) {
  console.log("AdditionalBoxController props:", props);
  const organisation_id = document._portalConfig.organisation_id;
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(
    props.activeStepAddDevice ? props.activeStepAddDevice : 0
  );
  const [message, setMessage] = useState();
  const [stepMessage, setStepMessage] = useState();
  const [showProcessing, setShowProcessing] = useState(false);
  const [showLoadingSubscription, setShowLoadingSubscription] = useState(true);
  const [showLoadingService, setShowLoadingService] = useState(false);
  const [showLoadingDevice, setShowLoadingDevice] = useState(true);
  const [showLoadingServiceDevice, setShowLoadingServiceDevice] =
    useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [devices, setDevices] = useState([]);
  const [services, setServices] = useState([]);
  const [serviceDevices, setServiceDevices] = useState([]);
  const [subscriptionSelected, setSubscriptionSelected] = useState();
  const [deviceSelected, setDeviceSelected] = useState([]);
  const [quantityService, setQuantityService] = useState(false);
  const [serviceSelected, setServiceSelected] = useState([]);
  const [serviceToReloadDevice, setServiceToReloadDevice] = useState(null);
  const [loadingState, setLoadingState] = useState(false);
  const [actionState, setActionState] = useState(false);

  const [activity, setActivity] = useState(props.activity);

  const { orderDetail } = props;
  const customerContact = orderDetail ? orderDetail : null;
  const products = {};
  const additionalServiceCfg = document._portalConfig.additional_service;
  const [additionalService, seAdditionalService] = useState([]);
  const [additionalServicePrices, setAdditionalServicePrices] = useState([]);
  const productDependenciesCfg = document._portalConfig.product_dependencies;

  useEffect(() => {
    if (customerContact) {
      onLoadSubscription();
      getTotalProduct();
    }
  }, [customerContact]);

  useEffect(() => {
    console.log("subscriptionSelected:", subscriptionSelected);
    if (subscriptionSelected) {
      if (activeStep == 0) {
        onLoadAllowDevices();
      } else {
        onLoadServices();
      }     
    }
  }, [subscriptionSelected]);

  useEffect(() => {
    if (activeStep == 1 && subscriptionSelected) {
      onLoadServices();
    }
  }, [activeStep]);

  const getTotalProduct = () => {
    let items = orderDetail.items ? orderDetail.items : [];
    const filterItems = items.filter((i) => {
      return i.product.sku != "Installation Service";
    });
    let quantity = filterItems ? filterItems.length : 0;
    setQuantityService(quantity);
  };

  const loadAdditionalService = async (subscription) => {
    const result = await crmservices.config.getProductBySku({ search_value: additionalServiceCfg });
    console.log('loadAdditionalService: ', result);
    if (result.code == "OK" && result.data && result.data.content && result.data.content.length > 0) {
      seAdditionalService(result.data.content[0]); 
      const resultProductPrice = await crmservices.config.getProductPrices(result.data.content[0].id);
      console.log('resultProductPrice: ', resultProductPrice);
      if(resultProductPrice.code == "OK" && resultProductPrice.data){
        setAdditionalServicePrices(resultProductPrice.data);
        // let aaa = getAdditionalServicePriceTerm(subscription, resultProductPrice.data);
      }
    }
  };

  const onLoadSubscription = async () => {
    let _subscriptions = [];
    try {
      const result = await crmservices.subscriptions.getContactSubscriptions(
        customerContact.id
      );
      console.log('onLoadSubscription: ', result);
      if (result.code == "OK") {
        _subscriptions = result.data.content ? result.data.content : [];
      }
    } catch (ex) {
      console.log("AAAAAAAA onLoadSubscription:", ex);
    }
    console.log("onLoadSubscription _subscriptions:", _subscriptions);
    if (_subscriptions.length > 0) {
      setSubscriptionSelected(_subscriptions[0]);
      await loadAdditionalService(_subscriptions[0]);
    }
    setSubscriptions(_subscriptions);
    setShowLoadingSubscription(false);
  };

  const onLoadAllowDevices = async () => {
    let devices = [];
    try {
      let myUserId = httpBackOfficeUtil.getSession().sub;
      devices = await crmservices.subscriptions.loadInstallerDevices({organisation_id, installerId: myUserId})
    } catch (ex) {
      console.log("onLoadAllowDevices Exception: ", ex);
    }
    // setDevices(devices);
    let services = await onLoadServices(false);
    await setAvailableDevices(devices, services);
    setShowLoadingDevice(false);
  };

  const setAvailableDevices = async(devices, services) => {    
    console.log('setAvaiableDevices devices= ', devices);
    console.log('setAvaiableDevices services= ', services);

    if(services && services.length > 0 && devices && devices.length > 0){
      let devicesTobeAdded = [];

      let productDependenciesTobeChecked = await loadDependencyRules();
      console.log('productDependenciesTobeChecked: ', productDependenciesTobeChecked);
      if(productDependenciesTobeChecked && productDependenciesTobeChecked.length > 0){
        for (let j = 0; j < devices.length; j++) {
          let productDevice = await onLoadProduct(devices[j].product.id);
          for (let i = 0; i < services.length; i++) {
            let service = services[i];
            let productService = await onLoadProduct(service.product.id);
            if(productService.classification != "EXPENSES_SERVICE"){
              if(productDependenciesTobeChecked && productDevice && productService){
                let isAvailable = await isAllowedDevice(productDependenciesTobeChecked, productService.type.name, productDevice.type.name)
                if(isAvailable && !devicesTobeAdded.includes(devices[j]))
                  devicesTobeAdded.push(devices[j]);          
              } 
            }         
          }
        }
        setDevices(devicesTobeAdded);
      } else
        setDevices(devices);
    }   
  }

  const loadAvailableDevicesByAService = async(devices, service) => {    
    console.log('setAvailableDevices devices= ', devices);
    console.log('setAvailableDevices service= ', service);

    if(service && devices && devices.length > 0){
      let devicesTobeAdded = [];

      let productDependenciesTobeChecked = await loadDependencyRules();
      console.log('productDependenciesTobeChecked: ', productDependenciesTobeChecked);
      if(productDependenciesTobeChecked && productDependenciesTobeChecked.length > 0){
        for (let j = 0; j < devices.length; j++) {
          let productDevice = await onLoadProduct(devices[j].device.product.id);
          let productService = await onLoadProduct(service.product.id);
            if(productService.classification != "EXPENSES_SERVICE"){
              if(productDependenciesTobeChecked && productDevice && productService){
                let isAvailable = await isAllowedDevice(productDependenciesTobeChecked, productService.type.name, productDevice.type.name)
                if(isAvailable && !devicesTobeAdded.includes(devices[j].device))
                  devicesTobeAdded.push(devices[j]);          
              } 
            }  
        }
        return devicesTobeAdded;
      } else
        return devices;
    }   
  }

  const loadDependencyRules = async() => {
    if(productDependenciesCfg && productDependenciesCfg != ""){
      console.log('loadDependencyRules load from config');
      return productDependenciesCfg;
    } else {
      let productDependencies = await crmservices.config.loadProductDependencies();
      console.log('loadDependencyRules = ', productDependencies);
      if (productDependencies.code == "OK") {
        productDependencies = productDependencies.data.content;
      } 
      // console.log('productDependencies = ', productDependencies);
      let productDependenciesTobeChecked = [];
      for (let r = 0; r < productDependencies.length; r++) {
        let pd = {name: productDependencies[r].item_name};
        // console.log('pd = ', pd);
        let prodRule = await onLoadProductDependencyRule(productDependencies[r].id);
        // console.log('prodRule = ', prodRule);
        if(prodRule){
          let dependencies = [];
          for(let d = 0; d < prodRule.dependencies.length; d++){
            dependencies.push(prodRule.dependencies[d].item_name);            
          }

          pd.dependencies = dependencies;
        }
        productDependenciesTobeChecked.push(pd);
      }

      return productDependenciesTobeChecked;
    }
  }

  const checkIfValueExists = (list, value) => {
    return list.some(obj => obj.name === value);
  };

  const isAllowedDevice = async (dependencies, serviceType, deviceType) => {
    const exist = checkIfValueExists(dependencies, serviceType);

    if(!exist)
      return true;

    for(let i = 0; i < dependencies.length; i++){
      let dp = dependencies[i];
      if(dp.name == serviceType && dp.dependencies.includes(deviceType)){
        return true;
      }
    }

    return false;
  }

  const onLoadServices = async (withDevice = true) => {
    setShowLoadingService(true);
    let services = [];
    try {
      // console.log("subscriptionSelected:", subscriptionSelected);
      // console.log("customerContact:", customerContact);
      const result = await crmservices.subscriptions.getContactServices({
        subscription_id: subscriptionSelected.id,
        contact_id: customerContact.id,
      });
      console.log("onLoadServices result:", result);
      if (result.code == "OK") {
        services = result.data.content ? result.data.content : [];
      }
    } catch (ex) {
      console.log("onLoadServices Exception:", ex);
    }
    let servicesWithDevices = [];

    if (services.length > 0) {
      for (let i = 0; i < services.length; i++) {
        let service = { ...services[i] };
        if(service.product && service.product.classification != "EXPENSES_SERVICE"){
          if(additionalServiceCfg && service.product.name == additionalServiceCfg){
            continue;
          }

          if(withDevice){
            const devices = await onLoadDeviceForService(service.id);
            const devicesTobeAdded = await loadAvailableDevicesByAService(devices, service);
            service.devices = devicesTobeAdded;
          }
          
          servicesWithDevices.push(service);
        }
      }
    }
    setServices(servicesWithDevices);
    setShowLoadingService(false);

    return servicesWithDevices;
  };

  const onLoadProductDependencyRule = async (prodDeRuleId) => {
    let prodDependRule = {}
    try {
      let data = await crmservices.config.getProductDependencyRule(prodDeRuleId)
      console.log(data);
      if (data.code == 'OK') {
        prodDependRule = data.data
      }
    } catch (ex) {
      console.log("onLoadTypeProductForService Exception:", ex);
    }
    return prodDependRule;
  }

  const onLoadProduct = async (productId) => {
    let product = products[productId];
    if(product != null){
        return product;
    }
   
    let prd = {}
    try {
        let data = await crmservices.config.getProduct(productId)
        if (data.code == 'OK') {
            prd = data.data
        }
    } catch (ex) {
        console.log("onLoadProduct Exception:", ex);
    }
    products[productId] = prd;
    return prd;
}

  const onLoadDeviceForService = async (serviceID) => {
    let devices = [];
    try {
      const result = await crmservices.subscriptions.getServiceDevices({
        service_id: serviceID,
      });
      console.log("onLoadDeviceForService result:", result);
      if (result.code == "OK") {
        devices = result.data.content ? result.data.content : [];
      }
    } catch (ex) {
      console.log("AAAAAAAA onLoadDeviceForService:", ex);
    }
    return devices;
  };

  const onSelectSubscription = (sub) => {
    setSubscriptionSelected(sub);
  };

  const onSelectServiceRow = (service) => {
    let existing = serviceSelected.filter((s) => {
      return s.service_id == service.id;
    });
    if (existing && existing.length > 0) {
      let _serviceSelected = serviceSelected.map((s) => {
        if (s.service_id == service.id) {
          s.is_active = true;
        } else {
          s.is_active = false;
        }
        return s;
      });
      setServiceSelected(_serviceSelected);
    } else {
      let _serviceSelected = serviceSelected.map((s) => {
        return { ...s, is_active: false };
      });
      let _newSelected = {
        service_name: service.product.name,
        service_id: service.id,
        device_id: null,
        device_serial_number: null,
        devices: [],
        is_active: true,
        is_checked: false,
      };
      _serviceSelected.push(_newSelected);
      console.log("_serviceSelected:", _serviceSelected);
      setServiceSelected(_serviceSelected);
      if (service.id != serviceToReloadDevice) {
        setServiceDevices([]);
        setServiceToReloadDevice(service.id);
      }
    }
  };
  const onSelectService = (service) => {
    let _newSelected = {};
    let existing = serviceSelected.filter((s) => {
      return s.service_id == service.id;
    });
    console.log("xxxxxx existing:", existing);
    if (existing && existing.length > 0) {
      let _serviceSelectedFilter = serviceSelected.filter((s) => {
        return s.service_id != service.id;
      });
      let _serviceSelected = _serviceSelectedFilter.map((s) => {
        return { ...s, is_active: false };
      });
      setServiceDevices([]);
      setServiceSelected(_serviceSelected);
    } else {
      let _serviceSelected = serviceSelected.map((s) => {
        return { ...s, is_active: false };
      });
      _newSelected = {
        service_name: service.product.name,
        service_id: service.id,
        device_id: null,
        device_serial_number: null,
        devices: [],
        is_active: true,
        is_checked: true,
      };
      _serviceSelected.push(_newSelected);
      console.log("_serviceSelected:", _serviceSelected);
      setServiceSelected(_serviceSelected);
      if (service.id != serviceToReloadDevice) {
        setServiceDevices([]);
        setServiceToReloadDevice(service.id);
      }
    }
  };

  const onSelectDeviceService = (service, device, isSelected) => {
    let _servicesSelected = [...serviceSelected];
    let existing = _servicesSelected.filter((s) => {
      return s.service_id == service.id;
    });
    console.log("existing:", existing);
    if (existing && existing.length > 0) {
      _servicesSelected = _servicesSelected.map((s) => {
        if (s.service_id == service.id) {
          let devices = [...s.devices];
          console.log("devices:", devices);
          console.log("isSelected:", isSelected);
          if (isSelected) {
            devices = devices.filter((d) => {
              return d.device_id != device.id;
            });
          } else {
            devices.push({
              device_id: device.id,
              device_serial_number: device.serial_number,
            });
          }
          s.devices = devices;
        }
        return s;
      });
      setServiceSelected(_servicesSelected);
    } else {
      let devices = [
        {
          device_id: device.id,
          device_serial_number: device.serial_number,
        },
      ];
      let newObj = {
        service_id: service.id,
        devices: devices,
        service_name: service.product.name,
      };
      let _serviceSelected = [...serviceSelected];
      _serviceSelected.push(newObj);
      setServiceSelected(_serviceSelected);
    }
  };

  const onSelectDevice = (undefined, device, isSelected) => {
    let _deviceSelected = [...deviceSelected];
    if (isSelected) {
        var index = _deviceSelected.indexOf(device);
        _deviceSelected.splice(index, 1);
    } else
        _deviceSelected.push(device);

    setDeviceSelected(_deviceSelected);
}

  const onSubmitStepAddDevice = async () => {
    setStepMessage(null);
    setActionState(null);
    setShowProcessing(true);
    try {
      let count = 0;
      let actionId = null;
      let devices = "";
      for (let i = 0; i < deviceSelected.length; i++) {
        devices += deviceSelected[i].serial_number + ",";
          
        const result = await crmservices.subscriptions.addSubscriptionDevices({
          subscription_id: subscriptionSelected.id,
          device_id: deviceSelected[i].id,
        });
        if (result.code == "OK") {
          actionId = result.data.id;
          count++;
        } else {
          let message =
            t("ADD_DEVICE_FAILED") +
            "(Serial Number: " +
            deviceSelected[i].serial_number +
            ")";
          if (result.code == "CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION") {
            message = t("ADD_DEVICE_CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION");
          }
          setStepMessage(message);
          break;
        }
      }
      if (count == deviceSelected.length) {
        setShowProcessing(false);
        setLoadingState(true);

        if(devices.endsWith(","))
            devices = devices.substr(0, devices.length - 1);

        await updateActivityCustomFieldsAddDevice(devices);
        const state = await checkSubscriptionExecuted(actionId);
        console.log("AAAA state:", state);
        if (state === "EXECUTED") { 
          setActiveStep(activeStep + 1);
        } else {
          setStepMessage(t("ACTION_REJECTED"));
        }
        setLoadingState(false);
        setActionState(state);
      }
    } catch (ex) {
      showMessage({ status: true, message: t("EXCEPTION_PROCESS") });
    }
    setShowProcessing(false);
  };

  function updateActivityCustomFieldsAddDevice(devices) {
    console.log("updateActivityCustomFieldsAddDevice...");
    try {
      let custom_fields = activity.custom_fields ? activity.custom_fields : [];
      custom_fields = createCustomFieldObj(custom_fields, "addingdevice", "1");
      custom_fields = createCustomFieldObj(custom_fields, "device_added", devices);
      
      let _activity = activity;
      _activity.custom_fields = custom_fields;
      setActivity(_activity);

      console.log("filterCustomFields ex:", custom_fields);
      crmservices.activities.updateActivityCustomFields({
        custom_fields: custom_fields,
        activity_id: activity.id,
      });
    } catch (ex) {
      console.log("updateActivityCustomFieldsAddDevice ex:", ex);
    }
  }

  function updateActivityCustomFieldsEnableDevice(key, isUpdateAgainAddingDevice) {
    console.log("updateActivityCustomFields...");
    try {
      let custom_fields = activity.custom_fields ? activity.custom_fields : [];
      
      let filterCustomFields = custom_fields.filter((c) => {
        return c.key != key;
      });
      filterCustomFields.push({
        key: key,
        value: "1",
      });
      if (isUpdateAgainAddingDevice) {
        filterCustomFields = filterCustomFields.filter((c) => {
          return c.key != "addingdevice";
        });
        filterCustomFields.push({
          key: "addingdevice",
          value: "1",
        });
      }
      console.log("filterCustomFields ex:", filterCustomFields);
      crmservices.activities.updateActivity({
        custom_fields: filterCustomFields,
        state: "COMPLETED",
        activity_id: activity.id,
      });
    } catch (ex) {
      console.log("AAAAAAA ex:", ex);
    }
  }

  const onSubmitStepEnableService = async () => {
    console.log("onSubmitStepEnableService subscriptionSelected:", subscriptionSelected);
    console.log("onSubmitStepEnableService serviceSelected: ", serviceSelected);
    console.log("onSubmitStepEnableService services:  ", services);

    let payload = createRequestToEnableService();
    console.log("onSubmitStepEnableService payload:  ", payload);
    if (payload.length == 0) {
      setStepMessage("Please select services and devices!");
      return;
    } else {
      setStepMessage(null);
      setActionState(null);
      setShowProcessing(true);
      try {
        let count = 0;
        for (let i = 0; i < payload.length; i++) {
          const result = await crmservices.subscriptions.enableDevices(
            payload[i]
          );
          console.log("onSubmitStepEnableService onSubmitStepEnableService result", result);
          if (result.code == "OK") {
            await sleep(3000);
            let state = await getSubscriptionActionState(result.data.id);
            console.log("onSubmitStepEnableService getSubscriptionActionState state: ", state);
            if (state === "EXECUTED") {
              count++;
              
              if(subscriptionSelected && subscriptionSelected.state == 'ACTIVE'){
                let activateServiceRsl = await activateServiceById(payload[i].service_id);
                console.log("onSubmitStepEnableService activateServiceRsl: ", activateServiceRsl);
                if(activateServiceRsl && activateServiceRsl.code != 'OK'){
                  setStepMessage((activateServiceRsl && activateServiceRsl.data && activateServiceRsl.data.message) 
                        ? activateServiceRsl.data.message : t('START_SERVICE_FAILURE')); 
                }
              }
            } else {
              let message =
                t("ACTION_REJECTED") + "  (" + payload[i].service_name + ")";
              setStepMessage(message);
              break;
            }
          } else {
            let message =
              t("ENABLE_DEVICE_FAILED") + "(" + payload[i].service_name + ")";
            setStepMessage(message);
            break;
          }
        }
        if (count == payload.length) {
          await updateActivityCustomFieldsEnableDevice("enable_device", true);
          await addAdditionalService();

          await sleep(1000);
          props.onClose(false);
          props.onLoadActivities();
          props.onCloseAll();
        }
      } catch (ex) {
        showMessage({ status: true, message: t("EXCEPTION_PROCESS") });
      }
      
      setShowProcessing(false);
    }
  }

  const activateServiceById = async(serviceId) => {
    console.log('activateService serviceId = ', serviceId);
    if(services && services.length > 0 && serviceId){
      for(const srv of services){
        if(srv.id == serviceId && srv.state != "EFFECTIVE"){
          let activateServiceRsl = await crmservices.subscriptions.activateService(serviceId);
          console.log('activateServiceRsl = ', activateServiceRsl);
          return activateServiceRsl;
        }
      }
    }    
  }

  const addAdditionalService = async() => {
    console.log("addAdditionalService services:  ", services);//this to enable device on service so ignore Additional fee and Expenses
    let contactServices = [];
    try {
      const contactServiceRsl = await crmservices.subscriptions.getContactServices({
        subscription_id: subscriptionSelected.id,
        contact_id: customerContact.id,
      });
      console.log("onLoadServices result:", contactServiceRsl);
      if (contactServiceRsl.code == "OK") {
        contactServices = contactServiceRsl.data.content ? contactServiceRsl.data.content : [];
      }
    } catch (ex) {
      console.log("onLoadServices Exception:", ex);
    }

    let addAdditionalServiceQty = 0;
    let addAdditionalServiceId = 0;
    if(contactServices && contactServices.length > 0){
      for(let s = 0; s < contactServices.length; s++){
        let srv = contactServices[s];
        if(srv.product.name == additionalServiceCfg){
          addAdditionalServiceQty = (srv.terms && srv.terms.quantity) ? srv.terms.quantity : 0;
          addAdditionalServiceId = srv.id;
        }
      }
    }

    console.log('addAdditionalService activity = ', activity);
    console.log('addAdditionalService addAdditionalServiceQty = ', addAdditionalServiceQty);
    console.log('addAdditionalService addAdditionalServiceId = ', addAdditionalServiceId);
    console.log('addAdditionalService serviceSelected = ', serviceSelected);
    
    let selectedDevices = [];
    if(serviceSelected && serviceSelected.length > 0){
      for(let s = 0; s < serviceSelected.length; s++){
        let sd = serviceSelected[s];
        if(sd.devices && sd.devices.length > 0){
          for(let d = 0; d < sd.devices.length; d++){
            selectedDevices.push(sd.devices[d].device_id);
          }
        }
      }
      console.log('selectedDeviceSerials: ', selectedDevices);
      let selectedDeviceSerialsRemoveDuplicated = removeDuplicates(selectedDevices);
      console.log('selectedDeviceSerialsRemoveDuplicated: ', selectedDeviceSerialsRemoveDuplicated);
      
      if(selectedDeviceSerialsRemoveDuplicated.length > 0){
        if(addAdditionalServiceQty > 0){//exist additional service on sub
          addAdditionalServiceQty = addAdditionalServiceQty + selectedDeviceSerialsRemoveDuplicated.length;
          const updateServiceRsl = await crmservices.subscriptions.updateService({ action: "CHANGE", quantity: addAdditionalServiceQty }, addAdditionalServiceId);
          console.log('updateServiceRsl: ', updateServiceRsl);
          if(updateServiceRsl.code != "OK")
              setMessage((updateServiceRsl && updateServiceRsl.data && updateServiceRsl.data.message) 
                              ? updateServiceRsl.data.message : t('UPDATE_SERVICE_FAILURE'));  
      } else {
          let addServiceRsl = await addSubscriptionService(selectedDeviceSerialsRemoveDuplicated.length);
          if (addServiceRsl.code == "OK") {
              let startServiceRsl = await activateAdditionalServiceIfExist();
              console.log('startServiceRsl: ', startServiceRsl);
              if(startServiceRsl && startServiceRsl.code != "OK")
                  setMessage((startServiceRsl.data && startServiceRsl.data.message) 
                              ? startServiceRsl.data.message : t('START_SERVICE_FAILURE'));  
          } else {
              setMessage((addServiceRsl && addServiceRsl.data && addServiceRsl.data.message) 
                              ? addServiceRsl.data.message : t('ADD_ADDITIONALSERVICE_FAILURE'));  
          }
        }
      }       
    }
  }

  const getActivityAddressId = () => {
    let addressId = null;
    if(activity){
      if(activity.address && activity.address.id){
        addressId = activity.address.id;
        console.log('populateAddressIdToDeviceCustomFields activity addressId= ', addressId);
      } else if(activity.contact && activity.contact.addresses && activity.contact.addresses.length > 0){
        addressId = activity.contact.addresses[0].id;
        console.log('populateAddressIdToDeviceCustomFields contact addressId= ', addressId);
      }
    }

    return addressId;
  }

  const populateAddressIdToDeviceCustomFields = async (deviceId) => {
    console.log('populateAddressIdToDeviceCustomFields deviceId = ', deviceId);
    let addressId = getActivityAddressId();
    console.log('populateAddressIdToDeviceCustomFields addressId = ', addressId);    
    if(deviceId && addressId){
        let device =  await crmservices.subscriptions.getDeviceById(deviceId);
        console.log('populateAddressIdToDeviceCustomFields device: ', device);
        if(device && device.code == 'OK' && device.data){
            let custom_fields = device.custom_fields ? device.custom_fields : [];

            custom_fields = createCustomFieldObj(custom_fields, "customer_address", addressId);
            await crmservices.subscriptions.updateDevice({ custom_fields: custom_fields }, deviceId);
        }
    }
  }

  const activateAdditionalServiceIfExist = async() => {
    const serviceRsl = await crmservices.subscriptions.getContactServices({
      subscription_id: subscriptionSelected.id,
      contact_id: customerContact.id,
    });
    console.log("activateAdditionalServiceIfExist serviceRsl: ", serviceRsl);
    if (serviceRsl.code == "OK") {
      const lsSerivces = serviceRsl.data.content ? serviceRsl.data.content : [];

      if(lsSerivces && lsSerivces.length > 0){
        for(let i = 0; i < lsSerivces.length; i++){
          if(lsSerivces[i].product.id == additionalService.id){
            const activateServiceRsl = await crmservices.subscriptions.activateService(lsSerivces[i].id);
            console.log('activateAdditionalServiceIfExist activateServiceRsl: ', activateServiceRsl);
          }
        }
      }
    }
  }

  const updateAdditionalService = async(qty) => {
    if(services && services.length > 0){
      for(let i = 0; i < services.length; i++){
        if(services[i].product.id == additionalService){

        }
      }
    }
  }

  const removeDuplicates = (arr) => {
    const uniqueArray = [...new Set(arr)];
    return uniqueArray;
  }

  const addSubscriptionService = async(qty) => {
    console.log('addSubscriptionService qty = ', qty);
    let services = [];
    let additionalServicePriceTermId = getAdditionalServicePriceTerm(subscriptionSelected, additionalServicePrices);
    console.log('addSubscriptionService additionalServicePriceTermId = ', additionalServicePriceTermId);
    
    let srv = {
        product_id: additionalService.id,
        price_terms_id: additionalServicePriceTermId,
        quantity: qty
    }

    services.push(srv);

    let payload = {
      services: services
    };
    console.log(' addSubscriptionService payload = ', payload);
    const result = await crmservices.subscriptions.addSubscriptionService({
      subscription_id: subscriptionSelected.id,
      reqBody: payload
    });
    console.log('addSubscriptionService result = ', result);
    return result;
  };
  
  const getAdditionalServicePriceTerm = (subscription, prices) => {
    console.log("getAdditionalServicePriceTerm subscription:", subscription);
    console.log("getAdditionalServicePriceTerm additionalServicePrices:", prices);
    if(subscription && prices && prices.length > 0){
      for(let i = 0; i < prices.length; i++){
        if(subscription.terms && subscription.terms.billing_period
          && subscription.terms.billing_period.duration
          && subscription.terms.billing_period.uot
          && prices[i].price_terms && prices[i].price_terms.billing_period
          && prices[i].price_terms.billing_period.duration
          && prices[i].price_terms.billing_period.uot
          && subscription.terms.billing_period.duration == prices[i].price_terms.billing_period.duration
          && subscription.terms.billing_period.uot == prices[i].price_terms.billing_period.uot
          && prices[i].prices.length > 0){
            return prices[i].prices[0].id;
          }
      }

      //no any case matches to the sub billing model so get a default config
      if(prices[0].prices.length > 0)
        return prices[0].prices[0].id;
    }

    return null;
  };

  const createRequestToEnableService = () => {
    let payload = [];
    serviceSelected.forEach((element) => {
      if (element.devices && element.devices.length > 0) {
        payload.push(element);
      }
    });
    return payload;
  };

  const checkSubscriptionExecuted = async (actionId) => {
    let attempts = 3;
    let currentState = "PENDING_VERIFICATION";
    while (currentState == "PENDING_VERIFICATION" && attempts > 0) {
      currentState = await getSubscriptionActionState(actionId);
      if (attempts != 3) await sleep(3000); //delay 3s after first attempt
      attempts--;
    }
    return currentState;
  };

  // const checkActiveTab = (activity) => {
	// 	let _active = 0;
	// 	let addingDevice = getCustomFieldByKey(activity.custom_fields, "adding_device");
	// 	let enable_device = getCustomFieldByKey(activity.custom_fields, "enable_device");
	// 	if(!addingDevice || addingDevice == "0"){
	// 		_active = 0;
	// 	}else{
	// 		if(!enable_device || enable_device == "0"){
	// 			_active = 1;
	// 		}else{
	// 			_active = 2;
	// 		}
	// 	}
	// 	setActiveStep(_active)
	// }

  // get state to use in updateActivityIfExecuted function
  const getSubscriptionActionState = async (actionId) => {
    let state = null;
    try {
      const result = await crmservices.subscriptions.getSubscriptionAction({
        action_id: actionId,
      });
      if (result.code === "OK") {
        state = result.data.state;
        console.log("SubscriptionActionState: ", state);
      }
    } catch (error) {
      console.log("get updatingState error:", error);
      state = "EXCEPTION";
    }
    return state;
  };

  const showMessage = ({
    status,
    title,
    message,
    otherMessage,
    callBackFn,
  }) => {
    setShowProcessing(false);
    setMessage({
      show: status,
      title: title,
      content: message,
      otherMessage,
      callBackFn: callBackFn ? callBackFn : () => setMessage({}),
    });
  };

  return (
    <>
      <AdditionalBoxView
        isOpen={props.isOpen}
        activeStep={activeStep}
        activity={activity}
        orderDetail={orderDetail}
        onClose={props.onClose}
        showLoadingSubscription={showLoadingSubscription}
        showLoadingDevice={showLoadingDevice}
        showLoadingService={showLoadingService}
        showLoadingServiceDevice={showLoadingServiceDevice}
        subscriptions={subscriptions}
        devices={devices}
        services={services}
        serviceDevices={serviceDevices}
        subscriptionSelected={subscriptionSelected}
        deviceSelected={deviceSelected}
        quantityPG={quantityService}
        message={message}
        stepMessage={stepMessage}
        serviceSelected={serviceSelected}
        loadingState={loadingState}
        actionState={actionState}
        onCancelAddDevice={props.onClose}
        onSelectSubscription={onSelectSubscription}
        onSelectDevice={onSelectDevice}
        onSelectService={onSelectService}
        onSelectDeviceService={onSelectDeviceService}
        onSubmitAddDevice={onSubmitStepAddDevice}
        onSubmitEnableService={onSubmitStepEnableService}
        onSelectServiceRow={onSelectServiceRow}
      />
      {showProcessing && <LoadingComponent showLoading={showProcessing} />}
      {message && message.show && (
        <AlertComponent
          isOpen={message.show}
          message={message.content}
          otherMessage={message.otherMessage ? message.otherMessage : null}
          onClose={message.callBackFn}
        />
      )}
      {loadingState && (
        <Dialog
          open={loadingState}
          sx={{ "& .MuiDialog-paper": { padding: "0px 0px" } }}
        >
          <LinearBuffer status={actionState} />
        </Dialog>
      )}
    </>
  );
}
